
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/appointments",
      function () {
        return require("private-next-pages/user/appointments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/appointments"])
      });
    }
  